import { Controller, Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";
import moment from "moment";

class SystemManager extends Controller {
	constructor () {
		super("systemManager");
		this.remoteClassName = "system";
	}

	checkAppVersion () {
		systemManager.getRemoteAppVersion()
		.then(response => {
			if (response?.data.version !== __VERSION__) {
				if (process.env.NODE_ENV === "development") {
					console.error("Versioni diverse:\nLocale: " + __VERSION__ + "\nRemota: " + response.data.version);
				}
				else {
					alert("Attenzione, la versione dell'app che stai usando non è la più recente, per favore ricarica la pagina del browser.\n\n(se questo messaggio si ripresenta dopo qualche tentativo di aggiornamento della pagina, svuota la cache del browser)\n\nLocale: " + __VERSION__ + "\nRemota: " + response.data.version);
					
					// const frm = document.createElement("form");
					// document.body.appendChild(frm);
					// frm.submit();
				}
			}
			else {
				console.log("%cVersioni uguali:\nLocale: " + __VERSION__ + "\nRemota: " + response.data.version, "color: #00FF00;");
			}
		});
	}

	getRemoteAppVersion () {
		const rd = NousCore.api.createRequest();
		const requestedAction = "get-app-version";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data?.items?.[0],
							requestedAction,
							status: "ok",
						};
					case 99:
						return {
							data: null,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
		// return fetch("/js/app-version.json")
		// .then(response => response.json())
		// .then(data => data);
	}

	getLatest (requestedTypes) {
		const rd = NousCore.api.createRequest( { item: { requestedTypes }});
		const requestedAction = "get-latest";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const responseData = {
							constructionSiteCardList: [],
						};

						if (data.items.length > 0) {
							const latestItem = data.items[0];

							if (latestItem.constructionSiteList) {
								responseData.constructionSiteList = Shark.getInstanceList("ConstructionSite", latestItem.constructionSiteList);
							}
							if (latestItem.constructionSiteCardList) {
								responseData.constructionSiteCardList = Shark.getInstanceList("ConstructionSiteCard", latestItem.constructionSiteCardList);
							}
							if (latestItem.notComplianceReportList) {
								responseData.notComplianceReportList = Shark.getInstanceList("NotComplianceReport", latestItem.notComplianceReportList);
							}
							if (latestItem.quotationList) {
								responseData.quotationList = Shark.getInstanceList("Quotation", latestItem.quotationList);

								const quotationRecap = {
									1: 0,//pending
									4: 0,//uploaded
								};
								
								responseData.quotationList.forEach(item => {
									if (quotationRecap.hasOwnProperty(item.status)) {
										quotationRecap[item.status]++;
									}
								});
								responseData.quotationRecap = quotationRecap;
							}
							if (latestItem.reportList) {
								responseData.reportList = Shark.getInstanceList("Visit", latestItem.reportList);

								const reportRecap = {
									1: 0,
									future_v: 0,
									future_p: 0,
									5: 0,
									6: 0,
								};
								
								const oneMonthAgo = moment().add(-1, "M");
			
								responseData.reportList.forEach(item => {
									if (item.referenceDate >= oneMonthAgo && reportRecap.hasOwnProperty(item.outcome)) {
										reportRecap[item.outcome]++;
									}
								});

								responseData.reportRecap = reportRecap;

							}
							if (latestItem.siteInfoSheetList) {
								responseData.siteInfoSheetList = Shark.getInstanceList("SiteInfoSheet", latestItem.siteInfoSheetList);

								// siteInfoSheetList.sort((a, b) => {
								// 	if (a.updatedAt < b.updatedAt) {
								// 		return 1;
								// 	}
								// 	else if (a.updatedAt > b.updatedAt) {
								// 		return -1;
								// 	}
								// });
			
								const siteInfoSheetRecap = {
									0: 0,//waiting
									1: 0,//pending
									4: 0,//Uploaded
								};
								
								//{0: 5, 1: 9, 2: 0, 3: 0, 4: 2}
								responseData.siteInfoSheetList.forEach(item => {
									if (siteInfoSheetRecap.hasOwnProperty(item.extraData.quotation.status)) {
										siteInfoSheetRecap[item.extraData.quotation.status]++;
									}
								});
								responseData.siteInfoSheetRecap = siteInfoSheetRecap;
			
								// const siteInfoSheetRequiresAttention = siteInfoSheetList.filter(item => item.extraData.quotation.status < 1);
							}
						}

						return {
							data: responseData,
							requestedAction,
							status: "ok",
						};
					}
					case 99:
						return {
							data: null,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}
}

const systemManager = new SystemManager();

Shark.registerController(systemManager);

export default systemManager;
